import React, {useEffect, useState} from "react";

import './_editCall.scss'
import {Link, useNavigate, useParams} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {grpcCallServiceSelector, grpcCustomerServiceSelector} from "../../../state/grpc";
import {
  Breadcrumb,
  BreadcrumbItem, Button, ButtonSet,
  Column,
  Form,
  Grid,
  Loading,
  Select, SelectItem,
  SelectSkeleton,
  TextInput, Tile
} from "@carbon/react";
import {ADD, useToastContext} from "../../../components/Toast";

const EditCall = () => {
  const {callID} = useParams();
  const [call, setCall] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState()
  const callService = useRecoilValue(grpcCallServiceSelector)
  const systemService = useRecoilValue(grpcCustomerServiceSelector)
  const [loadingSystems, setLoadingSystems] = useState(true)
  const [systems, setSystems] = useState([])
  const [saving, setSaving] = useState(false)
  const navigate = useNavigate()
  const {toastDispatch} = useToastContext();

  useEffect(() => {
    getSystems()
    if (callID === undefined) {
      setLoading(false)
      return
    }
    const req = new proto.api.GetCallConfigRequest()
    req.setCallConfigId(callID)
    callService.getCallConfig(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(err)
      } else {
        setCall(resp.toObject().callConfig)
      }
      setLoading(false)
    })
  }, [callID])

  const getSystems = () => {
    const req = new proto.api.ListCustomersRequest()
    systemService.listCustomers(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
      } else {
        setSystems(resp.toObject().customersList)
      }
      setLoadingSystems(false)
    })
  }

  if (loading) {
    return (
      <Loading/>
    )
  }

  const onSubmit = (ev) => {
    ev.stopPropagation()
    setSaving(true)
    const req = new proto.api.SaveCallConfigRequest()
    const callConfig = new proto.api.CallConfig()
    callConfig.setId(call.id)
    callConfig.setAlarmCode(call.alarmCode)
    callConfig.setDeviceCode(call.deviceCode)
    callConfig.setSystemCode(call.systemCode)
    callConfig.setSystemName(call.systemName)
    callConfig.setFromHour(call.fromHour)
    callConfig.setToHour(call.toHour)
    callConfig.setRecipientsList(call.recipientsList)
    callConfig.setMessage(call.message)
    req.setCallConfig(callConfig)
    if (callID === undefined) {
      callService.createCallConfig(req, null, (err, resp) => {
        handleCallSave(err, resp)
      })
    } else {
      callService.updateCallConfig(req, null, (err, resp) => {
        handleCallSave(err, resp)
      })
    }
  }

  const handleCallSave = (err) => {
    if (err != null) {
      console.error(err)
      toastDispatch({
        type: ADD,
        payload: {
          title: "Operazione fallita",
          content: "Impossibile salvare la configurazione",
          kind: "error",
          caption: err.message
        }
      })
    } else {
      toastDispatch({
        type: ADD,
        payload: {
          title: "Operazione avvenuta con successo",
          content: "Configurazione '" + name + "' salvata con successo",
          kind: "success"
        }
      })
      navigate("/system/calls")
    }
    setSaving(false)
  }

  if (error) {
    return (
      <Grid fullWidth className="calls-page">
        <Column lg={16} md={8} sm={4}>
          <Grid className="page-banner">
            <Column lg={16} md={4} sm={4}>
              <Breadcrumb noTrailingSlash aria-label="Page navigation">
                <BreadcrumbItem>
                  <Link to='/'>Home</Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to='/system/calls'>Centralino</Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  {callID !== undefined ? callID : "Nuova configurazione"}
                </BreadcrumbItem>
              </Breadcrumb>
            </Column>
            <Column lg={16} md={4} sm={4}>
              <h1 className="page-heading">
                {callID !== undefined ? "Modifica configurazione " + callID : "Nuova configurazione"}
              </h1>
            </Column>
          </Grid>
          <Grid>
            <Column lg={16} md={8} sm={4} className="calls-edit-page__r1">
              <span>Si è verificato un errore durante il caricamento della configurazione. Riprovare più tardi</span>
            </Column>
          </Grid>
        </Column>
      </Grid>
    )
  }

  return (
    <Grid fullWidth className="calls-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to='/system/calls'>Centralino</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                {callID !== undefined ? callID : "Nuova configurazione"}
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              {callID !== undefined ? "Modifica configurazione " + callID : "Nuova configurazione"}
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="calls-edit-page__r1">
            <Tile>
              <Form onSubmit={(ev) => onSubmit(ev)}>
                {
                  loadingSystems
                    ? <SelectSkeleton style={{marginBottom: '1rem'}}/>
                    : <Select
                      id="system-code"
                      labelText="Sistema"
                      data-modal-primary-focus
                      style={{marginBottom: '1rem'}}
                      value={call.systemCode}
                      onChange={ev => {
                        const systemName = ev.target.options[ev.target.selectedIndex].text
                        setCall({
                          ...call,
                          systemCode: ev.target.value,
                          systemName: systemName
                        })
                      }}>
                      <SelectItem
                        key=""
                        text="Seleziona un sistema"
                        value=""
                      />
                      {
                        systems.map(system =>
                          <SelectItem
                            key={system.code}
                            text={system.name}
                            value={system.code}
                          />)
                      }
                    </Select>
                }
                <TextInput
                  id="device-code"
                  labelText="Codice strumento"
                  placeholder="Codice strumento"
                  style={{marginBottom: '1rem'}}
                  value={call && call.deviceCode}
                  type="text"
                  onChange={ev => setCall({
                    ...call,
                    deviceCode: ev.target.value
                  })}
                />
                <TextInput
                  id="alarm-code"
                  labelText="Codice allarme"
                  placeholder="Codice allarme"
                  style={{marginBottom: '1rem'}}
                  value={call && call.alarmCode}
                  type="text"
                  onChange={ev => setCall({
                    ...call,
                    alarmCode: ev.target.value
                  })}
                />
                <TextInput
                  id="from-hour"
                  labelText="Dalle"
                  placeholder="es. 00:00:01"
                  style={{marginBottom: '1rem'}}
                  value={call && call.fromHour}
                  type="text"
                  onChange={ev => setCall({
                    ...call,
                    fromHour: ev.target.value
                  })}
                />
                <TextInput
                  id="to-hour"
                  labelText="Alle"
                  placeholder="es. 23:59:00"
                  style={{marginBottom: '1rem'}}
                  value={call && call.toHour}
                  type="text"
                  onChange={ev => setCall({
                    ...call,
                    toHour: ev.target.value
                  })}
                />
                <TextInput
                  id="message"
                  labelText="Messaggio"
                  placeholder="es. Attenzione! Pressione massima condensazione"
                  style={{marginBottom: '1rem'}}
                  value={call && call.message}
                  type="text"
                  onChange={ev => setCall({
                    ...call,
                    message: ev.target.value
                  })}
                />
                <TextInput
                  id="recipients"
                  labelText="Destinatari"
                  placeholder="Inserire numeri separati da virgola"
                  style={{marginBottom: '1rem'}}
                  value={(call && call.recipientsList) && call.recipientsList.join(',')}
                  type="text"
                  onChange={ev => setCall({
                    ...call,
                    recipientsList: ev.target.value.trim().split(',')
                  })}
                />
                <ButtonSet className="customers-edit-page__r1-form-btn">
                  <Button onClick={() => navigate("/system/calls")} kind="secondary">
                    Annulla
                  </Button>
                  <Button disabled={saving} type="submit" kind="primary">
                    {saving ? "Salvataggio in corso.." : "Salva"}
                  </Button>
                </ButtonSet>
              </Form>
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default EditCall